import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useApolloClient } from '@apollo/client';
import { Button, Space, Switch } from 'antd';
import { Header } from 'antd/es/layout/layout';
import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import EcfmgLogo from '../../../src/assets/ecfmg_header_logo.png';
import { IsInStorybookEnv } from '../../constants';
import { HandleLogout } from './handle-logout';
import { useTheme } from './theme-context';

const EcfmgHeader: React.FC = () => {
  const auth = useAuth();
  const apolloClient = useApolloClient();
  const [loggedInName, setLoggedInName] = React.useState<string | null>(null);
  const [loggedInNameInitials, setLoggedInNameInitials] = React.useState<string | null>(null);

  const handleLogout = () => {
    HandleLogout(auth, apolloClient, window.location.origin);
  };

  useEffect(() => {
    // This is to set mock user's name in storybook
    let firstName = '';
    let lastName = '';
    if (IsInStorybookEnv()) {
      firstName = 'John';
      lastName = 'Doe';
      setLoggedInNameInitials(`${firstName.charAt(0) || '?'}${lastName.charAt(0) || '?'}`);
      setLoggedInName(`${firstName} ${lastName}`);
      return;
    }

    if (auth.user) {
      if (auth.user.profile.name) {
        const [last, first] = auth.user.profile.name.split(', ');
        lastName = last || 'Unknown';
        firstName = first || 'User';
      }

      setLoggedInNameInitials(`${firstName.charAt(0) || '?'}${lastName.charAt(0) || '?'}`);
      setLoggedInName(`${firstName} ${lastName}`);
    }
  }, [auth]);

  const HeaderLeftCorner = (
    <div style={{ flexShrink: 0 }}>
      <img style={{ maxWidth: '150px' }} src={EcfmgLogo} />
    </div>
  );
  const { isDarkMode, toggleTheme } = useTheme();

  const HeaderRightCorner = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Space direction="horizontal">
        <Switch checked={isDarkMode} onChange={toggleTheme} checkedChildren={<SunOutlined />} unCheckedChildren={<MoonOutlined />} defaultChecked />
        <div
          style={{
            height: '30px',
            width: '30px',
            borderRadius: '15px',
            border: '1px solid white',
            textAlign: 'center',
            lineHeight: '30px'
          }}
        >
          {loggedInNameInitials || '?'}
        </div>
        <Space>
          <div>{loggedInName}</div>
          <Button style={{ color: 'white' }} type="link" onClick={handleLogout}>
            Logout
          </Button>
        </Space>
      </Space>
    </div>
  );

  return (
    <Header
      style={{
        background: '#3f4373',
        color: 'white',
        display: 'flex',
        padding: '0 16px',
        width: '100%',
        height: '60px',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        border: '10px solid #3f4373',
        left: 0,
        zIndex: 1000
      }}
    >
      {HeaderLeftCorner}
      {HeaderRightCorner}
    </Header>
  );
};

export default EcfmgHeader;
